import { Typography } from '@mui/material';
import BoxPlot, { Group } from '../../ui/BoxPlot';
import PercentileColorKey from '../../features/PercentileColorKey';
import { getColorGradient } from '../../utils/helpers';
import Accordion from '../../ui/Accordion';
import { components } from '../../api/types';

type Quantiles = components['schemas']['Quantiles'] | null;

type Props = {
  /* Measure data */
  measureName: string;
  measureCorrelationPercent: number;
  predictedScore: number;
  predictedStd: number;
  predictedPercentileRank: number | null;

  /* Diagnosis data */
  diagnosisName1: string;
  diagnosisName2: string;
  diagnosisColor1: string;
  diagnosisColor2: string;
  quantiles1: Quantiles;
  quantiles2: Quantiles;
};

/**
 * JSX Component containing proposed measure details
 * 
 * @param measure: Measure - proposed measure
 * 
 * @returns Measure vs diagnoses details element
 */
const MeasureSection = ({
  /* Measure data */
  measureName,
  measureCorrelationPercent,
  predictedScore,
  predictedStd,
  predictedPercentileRank,

  /* Diagnosis data */
  diagnosisName1,
  diagnosisName2,
  diagnosisColor1,
  diagnosisColor2,
  quantiles1,
  quantiles2,
}: Props): JSX.Element => {

  const clientGroup: Group = {
    title: 'Client Prediction',
    value: predictedScore,
    std: predictedStd,
    percentile: (predictedPercentileRank ?? 0) * 100,
    color: getColorGradient((predictedPercentileRank ?? 0) * 100).backgroundColor,
  };

  const populationGroup1: Group = {
    title: `${diagnosisName1}`,
    box: quantiles1,
    // color: diagnosisColor1,
    color: "#3e68d1",
  };

  const populationGroup2: Group = {
    title: `${diagnosisName2}`,
    box: quantiles2,
    // color: diagnosisColor2,
    color: "#3e68d1",
  };

  // <span>Based on InsightCare's model, this measure has a</span>
  // <span>{` ${measureCorrelationPercent.toFixed(2)} `}</span>
  // <span>correlation with differentiating</span>
  // <span className={diagnosisAndColor1.className}>{` ${diagnosisAndColor1.diagnosisName} `}</span>
  // <span>from</span>
  // <span className={diagnosisAndColor2.className}>{` ${diagnosisAndColor2.diagnosisName}`}</span>
  // <span>.</span>

  return (
    <>
      {/* <Typography>{measureName}</Typography>
      <Typography>
        {"Based on InsightCare's model, this measure has a "}
        {measureCorrelationPercent.toFixed(2)}
        {" correlation with differentiating "}
        <Typography component="span" sx={{color: diagnosisColor1}}>{diagnosisName1}</Typography>
        {" from "}
        <Typography component="span" sx={{color: diagnosisColor2}}>{diagnosisName2}</Typography>
        {"."}
      </Typography> */}

      <Typography sx={{fontSize: 24}}>{measureName}</Typography>
      <span>Based on InsightCare's model, this measure has a</span>
      <span>{` ${measureCorrelationPercent.toFixed(2)} `}</span>
      <span>correlation with differentiating </span>
      <span style={{color: diagnosisColor1}}>{diagnosisName1}</span>
      <span> from </span>
      <span style={{color: diagnosisColor2}}>{diagnosisName2}</span>
      <span>.</span>

      <Accordion title={<div style={{ display: "inline" }}>In-Depth Analysis</div>}>
        <BoxPlot groups={[clientGroup, populationGroup1, populationGroup2]} />
        <PercentileColorKey />
      </Accordion>
    </>
  );
};

export default MeasureSection;